import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { api } from '../utils/api'

export default function ProtectedRoute({ children }) {
  const [authed, setAuthed] = useState(null)

  useEffect(() => {
    const token = localStorage.getItem('temple_jwt')
    if (!token) { setAuthed(false); return }

    api.get('/auth/me')
      .then(() => setAuthed(true))
      .catch(() => {
        localStorage.removeItem('temple_jwt')
        setAuthed(false)
      })
  }, [])

  if (authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="text-charcoal/40 text-sm">Loading...</div>
      </div>
    )
  }

  return authed ? children : <Navigate to="/admin/login" replace />
}
